/** @jsx jsx */
import styled from '@emotion/styled';

const LabelHeading = styled.h4`
  margin: 0 0 8px 0;
  padding: 0;
  font-weight: normal;
  font-size: 1.6rem;
`;

export { LabelHeading };
